import React from 'react';
import AdminSidebar from './AdminSidebar';
import AdminTopbar from './AdminTopbar';
import { useAdminContext } from '../../../context/AdminContext';
import { useUnsavedChangesGuard } from '../../hooks/useUnsavedChangesGuard';

const AdminShell: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { dirty } = useAdminContext();
  useUnsavedChangesGuard(dirty);

  return (
    <div className="admin-shell min-h-screen">
      <div className="mx-auto flex max-w-[1680px] gap-6 px-4 py-4 lg:px-6">
        <AdminSidebar />
        <main className="min-w-0 flex-1">
          <AdminTopbar />
          <div className="space-y-6 pb-10">{children}</div>
        </main>
      </div>
    </div>
  );
};

export default AdminShell;
